function DatePicker(props) {
  return props.hidden
            ? <></>
            : <div className={(props.classDiv ?? 'sm:rtds-flex-1 ') + 'rtds-input-field rtds-gap-1'} hidden={props.hidden}>
               { !props.hideSubTitle && (
                <label htmlFor={props.id} className={(props.classLabel ?? 'rtds-sr-only ') + 'rtds-input-field__label' }>
                  {props.label}
                </label>)}

                { props.hideSubTitle && (
               <label htmlFor={props.id} className={'rtds-input-field__label ' + props.classLabel} hidden={!props.hideSubTitle}>
                  {props.label}
                  <abbr
                    hidden={!props.required}
                    className='rtds-font-bold rtds-no-underline'
                    title='obbligatorio'
                  >
                    *
                  </abbr>
                </label> )}

                <div className={(props.classDivInput ?? 'rtds-input') + (props.inputErrors?.includes(props.id) ? ' has-error' : '')}>
                  <input
                    required={props.required}
                    id={props.id}
                    name={props.id}
                    className={props.classInput + (props.disabled || props.readOnly ? ' rtds-background-02' : '')}
                    type={props.type}
                    aria-describedby={`${props.id}Description ${props.id}Error`}
                    onInput={(event) => props.onInput(event)}
                    aria-invalid={props.inputErrors?.includes(props.id)}
                    defaultValue={props.defaultValue}
                    min={props.min}
                    max={props.max}
                    disabled={props.disabled || props.readOnly}
                    title={props.title}
                    hidden={props.hidden}
                  />
                  {/* {
                    props.inputErrors?.includes(props.id) && 
                    <svg
                      className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-absolute rtds-right-4 rtds-content-placeholder rtds-content-error'
                      aria-hidden='true'
                      focusable='false'
                      role='img'
                    >
                      <use
                        xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--exclamation-circle`}
                      />
                    </svg>
                  } */}
                </div>

                <span className='rtds-input-field__hint' hidden={props.hideSubTitle}>
                  <span className='rtds-input-field__description' id={props.id + 'Description'}>
                    {props.label} - formato gg/mm/aaaa hh:mm
                  </span>
                </span>

                <span className='rtds-input-field__hint' hidden={!props.inputErrors?.includes(props.id)}>
                  <span
                    className='rtds-input-field__error'
                    id={props.id + 'Error'}
                    aria-live='assertive'
                  >
                    {props.errorMessage ?? 'Campo obbligatorio'}
                  </span>
                </span>
              </div>;
}

export default DatePicker;
